const materialTermsView = (data) => {
  let formData =
    data &&
    data.getMaterialTermsById &&
    data.getMaterialTermsById.MaterialTermsFormData;
  if (formData) {
    let view = {
      name: formData.new_profile_material_terms_profile_name,
      sections: [
        {
          name: "Material Terms of Employment",
          fields: [
            {
              number: 1,
              label: "Profile Name",
              value: formData.new_profile_material_terms_profile_name,
            },
            {
              number: 2,
              label: "Section of Material Term or Condition",
              value: formData.new_profile_material_terms_section_number,
            },
            {
              number: 3,
              label: "Summary of Material Term or Condition",
              value: formData.new_profile_material_terms_summary,
            },
            {
              number: 3,
              label: "Details of Material Term or Condition",
              value: formData.new_profile_material_terms_details,
            },
          ],
        },
      ],
    };
    return view;
  }
};

export default materialTermsView;
